
import TableList from '@/components/TableList/index.vue';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { channelList } from '@com/utils/channel';
export default {
  components: {
    TableList: TableList
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tableConfig: {},
      tableColumnConfig: [{
        label: 'ID',
        prop: 'id',
        width: 70
      }, {
        label: '素材Id',
        prop: 'dco_id'
      }, {
        label: '组合Id',
        prop: 'gid'
      }, {
        label: '渠道',
        prop: 'traffic_type',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return useValueExchangeLabel(row.traffic_type, channelList);
          }
        }
      }, {
        label: '平台',
        prop: 'platform'
      }, {
        label: '语言',
        prop: 'language'
      }, {
        label: '分辨率',
        prop: 'resolution'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }]
    };
  },

  methods: {},
  computed: {
    // 过滤表数据
    filterColumnConfig: function filterColumnConfig() {
      var _this = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    }
  }
};